// Share buttons (client) — uses native share API + fallback to clipboard
"use client";

import { Facebook, Twitter, Linkedin, Link2, Check } from "lucide-react";
import { useState } from "react";

export default function ShareButtons({ url, title }: { url: string; title: string }) {
  const [copied, setCopied] = useState(false);
  const encoded = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  };

  const items = [
    { label: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encoded}`, color: "hover:bg-[#1877F2] hover:text-white" },
    { label: "X (Twitter)", icon: Twitter, href: `https://twitter.com/intent/tweet?url=${encoded}&text=${encodedTitle}`, color: "hover:bg-black hover:text-white" },
    { label: "LinkedIn", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${encoded}`, color: "hover:bg-[#0A66C2] hover:text-white" },
  ];

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-slate-500 mr-2">Udostępnij:</span>
      {items.map((it) => (
        <a
          key={it.label}
          href={it.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={it.label}
          className={`w-9 h-9 inline-flex items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 transition-colors ${it.color}`}
        >
          <it.icon className="w-4 h-4" />
        </a>
      ))}
      <button
        type="button"
        onClick={copy}
        aria-label="Kopiuj link"
        className="w-9 h-9 inline-flex items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 hover:bg-slate-900 hover:text-white transition-colors"
      >
        {copied ? <Check className="w-4 h-4" /> : <Link2 className="w-4 h-4" />}
      </button>
    </div>
  );
}
